import React from 'react';
import { Link } from 'react-router-dom';

function CTA() {
  return (
    <div className="cta-section mt-24 relative overflow-hidden rounded-[40px] border border-gray-100 bg-white p-1">
      {/* High-End Gradient Border Wrapper */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#952877]/20 via-transparent to-[#592aa7]/20 opacity-50"></div>
      
      <div className="relative bg-white rounded-[38px] px-8 py-16 md:py-20 text-center shadow-2xl shadow-purple-100/50">
        
        {/* Abstract Background Accents */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full pointer-events-none">
          <div className="absolute -top-24 left-10 w-64 h-64 bg-[#952877]/10 blur-[100px] rounded-full"></div>
          <div className="absolute -bottom-24 right-10 w-64 h-64 bg-[#592aa7]/10 blur-[100px] rounded-full"></div>
        </div>

        <div className="relative z-10 max-w-4xl mx-auto">
          <div className="cta-animate mb-10">
            {/* Tagline */}
            <span className="inline-block py-1 px-4 rounded-full bg-[#952877]/5 text-[#952877] font-bold text-sm tracking-widest uppercase mb-6">
              Ready to Scale?
            </span>
            
            <h3 className="text-4xl lg:text-6xl font-extrabold text-[#17091a] mb-8 leading-[1.15]">
              Let's Transform Your Business with 
              <span className="block bg-gradient-to-r from-[#952877] to-[#592aa7] bg-clip-text text-transparent mt-2">
                Intelligent AI Solutions
              </span>
            </h3>
            
            <p className="text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed">
              Don't let your competitors get ahead. Schedule a free consultation and discover how our proven AI development process can revolutionize your business operations.
            </p>
          </div>

          {/* Action Button */}
          <div className="cta-animate">
            <Link 
              to="/contact"
              className="group relative inline-flex items-center justify-center px-12 py-5 bg-[#17091a] text-white font-bold text-lg rounded-2xl overflow-hidden transition-all duration-300 hover:scale-105 hover:shadow-[0_20px_40px_rgba(149,40,119,0.3)]"
            >
              {/* Button Gradient Overlay */}
              <div className="absolute inset-0 bg-gradient-to-r from-[#952877] to-[#592aa7] opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              
              <span className="relative z-10 flex items-center">
                Get Started Now
                <svg 
                  className="w-6 h-6 ml-3 transform group-hover:translate-x-2 transition-transform duration-300" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </span>
            </Link>
            

          </div>
        </div>
      </div>
    </div>
  );
}

export default CTA;